export const endUserCategorySchema = {
	schema: {
		title: 'end user category schema',
		description: 'End User Category Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			category_code: {
				type: 'string',
			},
			category_name: {
				type: 'string',
			},
			is_active: {
				type: 'boolean',
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
		},
		required: ['id', 'category_code', 'category_name', 'is_active'],
	},
};
